<template>
  <header class="c-cbr-Header">
    <span 
      v-if="stage !== 'prod'" 
      :class="[$style.stageClass, $style[stage]]"
    >[{{ stage }}]</span>
    
    <slot 
      name="logo" 
      class="c-cbr-Header-logo">
      <cbr-logo 
        :src="logo" 
        position="left"/>
    </slot>

    <slot name="navigation">
      <cbr-navigation/>
    </slot>

  </header>
</template>

<script>
import CbrLogo from './CbrLogo.vue';
import CbrNavigation from './CbrNavigation.vue';

export default {
  components: {
    CbrLogo,
    CbrNavigation
  },
  props: {
    logo: {
      type: String,
      default: '/assets/gls_logo.png'
    }
  },

  data() {
    return {
      logoSrc: '/assets/gls_logo.png',
      stage: process.env.STAGE
    }
  }
}
</script>

<style module>
  .stageClass {
    font-size: 20px;
    font-weight: 500;
    margin-right: 10px;
  }

  .local {
    color: #d84315;
  }

  .dev {
    color: #1a237e;
  }

  .stage {
    color: #1b5e20;
  }
</style>



// WEBPACK FOOTER //
// client/components/CbrHeader.vue